export default __webpack_public_path__ + "static/sally-e2c1c22a703ccc581184c6ec5f4a8292.png";